module.exports = __webpack_public_path__ + "img/casa.b341b0c7.svg";